import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * 車アイコン
 */
const CarIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.5"
        height="14.667"
        viewBox="0 0 16.5 14.667"
      >
        <path
          d="M17.593,5.926A1.37,1.37,0,0,0,16.292,5H6.208a1.378,1.378,0,0,0-1.3.926L3,11.417V18.75a.919.919,0,0,0,.917.917h.917a.919.919,0,0,0,.917-.917v-.917h11v.917a.919.919,0,0,0,.917.917h.917a.919.919,0,0,0,.917-.917V11.417ZM6.208,15.083a1.375,1.375,0,1,1,1.375-1.375A1.373,1.373,0,0,1,6.208,15.083Zm10.083,0a1.375,1.375,0,1,1,1.375-1.375A1.373,1.373,0,0,1,16.292,15.083ZM4.833,10.5,6.208,6.375H16.292L17.667,10.5Z"
          transform="translate(-3 -5)"
        />
      </svg>
    </Icon>
  )
}

export default CarIcon
